// extracted by mini-css-extract-plugin
export default {"container":"styles_container__7e9c+","footer":"styles_footer__ueHi+","dataNotFound":"styles_dataNotFound__ZqFF4"};